import { useFormDesignSelectOptions } from "components/UI/Selects/FormDesignSelectSearchable/useFormDesignSelectOptions.ts";
import { SearchableSelect, SearchableSelectWrapperProps } from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

import FilterRequest = App.Http.Requests.FilterRequest;

type FormDesignSelectSearchableProps = SearchableSelectWrapperProps & {
    filter?: FilterRequest;
};

export const FormDesignSelectSearchable = ({ filter, ...props }: FormDesignSelectSearchableProps) => {
    const hookResult = useFormDesignSelectOptions({ filter });

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.form_design"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
